/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1IndividualpaymentParcelsParcelidActivateMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidActivatePathParams,
  PostApiV1IndividualpaymentParcelsParcelidActivate400,
  PostApiV1IndividualpaymentParcelsParcelidActivate401,
  PostApiV1IndividualpaymentParcelsParcelidActivate500,
} from "../../types/individualPaymentOperationsController/PostApiV1IndividualpaymentParcelsParcelidActivate.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1IndividualpaymentParcelsParcelidActivate } from "../../clients/individualPaymentOperationsController/postApiV1IndividualpaymentParcelsParcelidActivate.ts";

export const postApiV1IndividualpaymentParcelsParcelidActivateMutationKey =
  () =>
    [{ url: "/api/v1/individualpayment/parcels/:parcelId/activate" }] as const;

export type PostApiV1IndividualpaymentParcelsParcelidActivateMutationKey =
  ReturnType<
    typeof postApiV1IndividualpaymentParcelsParcelidActivateMutationKey
  >;

export function postApiV1IndividualpaymentParcelsParcelidActivateMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey =
    postApiV1IndividualpaymentParcelsParcelidActivateMutationKey();
  return mutationOptions<
    PostApiV1IndividualpaymentParcelsParcelidActivateMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidActivate400
      | PostApiV1IndividualpaymentParcelsParcelidActivate401
      | PostApiV1IndividualpaymentParcelsParcelidActivate500
    >,
    {
      parcelId: PostApiV1IndividualpaymentParcelsParcelidActivatePathParams["parcelId"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ parcelId }) => {
      return postApiV1IndividualpaymentParcelsParcelidActivate(
        parcelId,
        config,
      );
    },
  });
}

/**
 * @description Apenas parcelas canceladas podem ser reativadas. Migrado do legado IndividualPayment/ActivateParcel. **(Requer Authorization para autenticação)**
 * @summary Reativa uma parcela cancelada (volta a pendente) (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/parcels/:parcelId/activate}
 */
export function usePostApiV1IndividualpaymentParcelsParcelidActivate<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1IndividualpaymentParcelsParcelidActivateMutationResponse,
      ResponseErrorConfig<
        | PostApiV1IndividualpaymentParcelsParcelidActivate400
        | PostApiV1IndividualpaymentParcelsParcelidActivate401
        | PostApiV1IndividualpaymentParcelsParcelidActivate500
      >,
      {
        parcelId: PostApiV1IndividualpaymentParcelsParcelidActivatePathParams["parcelId"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1IndividualpaymentParcelsParcelidActivateMutationKey();

  const baseOptions =
    postApiV1IndividualpaymentParcelsParcelidActivateMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiV1IndividualpaymentParcelsParcelidActivateMutationResponse,
      ResponseErrorConfig<
        | PostApiV1IndividualpaymentParcelsParcelidActivate400
        | PostApiV1IndividualpaymentParcelsParcelidActivate401
        | PostApiV1IndividualpaymentParcelsParcelidActivate500
      >,
      {
        parcelId: PostApiV1IndividualpaymentParcelsParcelidActivatePathParams["parcelId"];
      },
      TContext
    >;

  return useMutation<
    PostApiV1IndividualpaymentParcelsParcelidActivateMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidActivate400
      | PostApiV1IndividualpaymentParcelsParcelidActivate401
      | PostApiV1IndividualpaymentParcelsParcelidActivate500
    >,
    {
      parcelId: PostApiV1IndividualpaymentParcelsParcelidActivatePathParams["parcelId"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1IndividualpaymentParcelsParcelidActivateMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidActivate400
      | PostApiV1IndividualpaymentParcelsParcelidActivate401
      | PostApiV1IndividualpaymentParcelsParcelidActivate500
    >,
    {
      parcelId: PostApiV1IndividualpaymentParcelsParcelidActivatePathParams["parcelId"];
    },
    TContext
  >;
}
